module.exports = __webpack_public_path__ + "img/title-2.e9659bc1.png";